import { connect } from 'react-redux'
import { Component, useState } from "react"
import {isMobile} from 'react-device-detect';
import * as THREE from 'three';
import {
  CloseButton,
  Button,
  LoadingOverlay,
  Popover,
  ScrollArea,
  Accordion,
  Drawer,
  TextInput,
  ActionIcon,
  Divider,
  Paper
} from "@mantine/core";
import {IconRouteSquare, IconXboxX, IconEye, IconSquareRoundedXFilled, IconDeviceFloppy} from '@tabler/icons-react';
import { v4 as uuidv4 } from 'uuid';
import{ onEditMode, onAdminActionCaravanserailStreetLinking } from "../../actions" 
import {drawRoadFromTo, manageSelection, PAS_FOR_ROAD, PointPoisition0} from "../../game"


function CopyUidLink({ uid }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault(); // évite la navigation du <a>
    const text = String(uid ?? "");

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) {
      // Fallback ancien navigateur
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }
  };

  return (
    <a
      href="#"
      onClick={handleCopy}
      aria-label={`Copier l'UID ${uid}`}
      title={copied ? "Copié !" : "Cliquer pour copier"}
      style={{fontSize: "1.1rem", fontWeight:"normal",  textDecoration: "underline", display: "inline-block",  cursor: "pointer", maxWidth: "180px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace: "nowrap", verticalAlign:"middle" }}
    >
      {copied ? "Copié !" : uid}
    </a>
  );
}



const pathContext = {
  scene3D: null,
  addMode: false,
  points: {},
  paths: [],
  select_path :  null,
  accordion:{ 
    path: "",
    point: "",
  },
  version: 0,
  trash: [],
  shaps: [],
  floating_point: null,
  floating_between: null,
  pointBetween: [],
  mode_between: false,
  last_mouse_mv: null,
  close_points: [],
  last_version: 0,
  version: 0,
  loading: false,
  toSave: false
}

const defaultLabel = 'Chemin inconnu'

let trash_floating = []
let trash_path = []

let mouse_up_rebond
let mouse_mv_rebond
let mouse_dwn_rebond
let mode_between_timer
let load_rebond

class PathEditor extends Component{
  constructor(props) {
      super(props)
      
      this.state = pathContext
  }

  makeStateCopy(){
      return {
          scene3D: this.state.scene3D,
          points: this.state.points,
          addMode: this.state.addMode,
          select_path: this.state.select_path,
          accordion: this.state.accordion,
          paths: this.state.paths,
          trash: this.state.trash,
          close_points: this.state.close_points,
          floating_point: this.state.floating_point,
          last_version: this.state.version,
          pointBetween: this.state.pointBetween,
          floating_between: this.state.floating_between,
          mode_between: this.state.mode_between,
          version: this.state.version + 1,
          loading: this.state.loading,
          last_mouse_mv: this.state.last_mouse_mv,
          toSave: this.state.toSave,   
      }
  }

  componentDidMount() {
    const self = this

    this.props.notification.addNotification("Object3DClearSelection", async (type, msg, arg)=>{
      const state = this.makeStateCopy()
      if(state.select_path)
      {
           state.select_path.node.point.select = false
          state.select_path.node.point.up = false
      }
      this.setState(state)
  })

    if(this.props.notification){ 
      this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
        if(!load_rebond){ 
          load_rebond = setInterval(async ()=>{
            clearInterval(load_rebond)
            let state = self.makeStateCopy()
            
            state.loading = true
            this.setState(state)
            state.scene3D = arg

            const {paths: paths, points: points} =  await this.load(state) || []
            if(paths){ 
              state.points = points
              state.paths = paths
            }
            state.loading = false
            self.setState(state)
          }, 50)
        }
      })
      
      this.props.notification.addNotification("mouseup", (type, msg, arg)=>{
        if(!mouse_up_rebond){
          mouse_up_rebond = setInterval(()=>{
            clearInterval(mouse_up_rebond)
            mouse_up_rebond = undefined
            self.onMouseUp(msg)
          }, 5)
          
        }
      })
      this.props.notification.addNotification("mousedown", (type, msg, arg)=>{
        if(!mouse_dwn_rebond){
          mouse_dwn_rebond = setInterval(()=>{
            clearInterval(mouse_dwn_rebond)
            mouse_dwn_rebond = undefined
            self.onMouseDwon(msg)
          }, 5)
          
        }
      })
      this.props.notification.addNotification("mousemove", (type, msg, arg)=>{
        if(!mouse_mv_rebond){
          mouse_mv_rebond = setInterval(()=>{
            clearInterval(mouse_mv_rebond)
            mouse_mv_rebond = undefined
            self.onMouseMove(msg)
          }, 5)
        }
      })

      this.state.timer_animation = setInterval(()=>{
        self.render3D()
      }, 100)
    }
  }

  getSaveMap(state){
    const points = []
    const points_relation = {}
    const relations = []
    const paths = []
    const paths_uid = {}

    for(let i=0; i < state.paths.length; i ++){
      const path = state.paths[i]
      if(!path.toSave) continue
      let uid = paths.length

      const p = {
        nom: path.nom,
       
      }

      if(path.renew){
        path.renew = false
        p.renew = true
        for(let n=0; n < path.nodes.length; n ++){
          path.nodes[n].toSave = true
        }
      }
      if(path.uid.indexOf("fak-") < 0){
        p.uid = path.uid
      }
      paths_uid[path.uid] = uid
      paths.push(p)

      
    }

    for(let l in state.points){
      const node = state.points[l]

      if(!node.toSave) continue
      const point = {
        lngLat: node.point.lngLat
      }
      let uid = points.length
      if(node.point.uid && node.point.uid.indexOf("fak-") < 0){
        point.uid = node.point.uid
        //uid = node.point.uid
      }

      points.push(point)

      points_relation[node.point.uid] = uid
      
    }

    for(let uid in state.points){
      const node = state.points[uid]

      if(!node.toSave) continue

      if(node.next){

        if(paths_uid[node.next.path.uid] === undefined){
          let n = paths.length
          const p = {
            nom: node.next.path.nom,
           
          }
          if(node.next.path.uid.indexOf("fak-") < 0){
            p.uid = node.next.path.uid
          }
          paths.push(p)
          paths_uid[node.next.path.uid] = n
        }

        if(points_relation[node.next.point.uid] === undefined){
          const point = {
            lngLat: node.next.point.lngLat
          }

          if(node.next.point.uid && node.next.point.uid.indexOf("fak-") < 0){
            point.uid = node.next.point.uid
          }

          points_relation[node.next.point.uid] = points.length

          points.push(point)
        }
        
        relations.push({
          'a': points_relation[node.point.uid],
          'b': points_relation[node.next.point.uid],
          "type": "normal",
          "nom": node.next.path.nom,
          uid: paths_uid[node.next.path.uid]
        })
      }

      for(let l in node.children){
        const child = node.children[l]
        if(!paths_uid[child.path.uid]){
          let n = paths.length
          const p = {
            nom: child.path.nom,
           
          }
          if(child.path.uid.indexOf("fak-") < 0){
            p.uid = child.path.uid
          }
          paths.push(p)
          paths_uid[child.path.uid] = n
        }

        if(points_relation[child.point.uid] === undefined){
          const point = {
            lngLat: child.point.lngLat
          }

          if(child.point.uid && child.point.uid.indexOf("fak-") < 0){
            point.uid = child.point.uid
          }

          points_relation[child.point.uid] = points.length

          points.push(point)
        }

        relations.push({
          'a': points_relation[node.point.uid],
          'b': points_relation[child.point.uid],
          "type": "child",
          "nom": child.path.nom,
          uid: paths_uid[child.path.uid]
        })
      }
    }

    return {
      points: points,
      paths: paths,
      relations : relations
    }
  }

  clearSave(state){
    for(let i=0; i < state.paths.length; i ++){
      const path = state.paths[i]
      if(!path.toSave) continue
      path.toSave = false
    }

    for(let l in state.points){
      const node = state.points[l]

      if(!node.toSave) continue
      node.toSave = false
    }
    state.toSave = false
  }

  async load() {
    
    console.log("Path.index.load")
    const uri = "/get/paths"
    const response = await fetch(uri, {
        method: "GET",
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
        }
    })
    if(response.status === 200) { 

        const datas = await response.json();
        if(!datas.relations) return {}
        const state = {
          points: {},
          paths: []
        }
       
        const paths_uid = {}


        for(var uid in datas.paths){
          const p = datas.paths[uid]
          const path = {
            nom: p.nom,
            uid: uid,
            nodes: []
          }
          state.paths.push(path)
          paths_uid[uid] = path
        }

        for(var uid in datas.points){
          const point = datas.points[uid]
          const p = {
            point: {
              lngLat: new window.maplibregl.LngLat(point.lngLat.lng , point.lngLat.lat),
              uid: uid,
            },
            
            children: [],
            toSave: false,
            path: paths_uid[point.path],
            next: null,
            pred: null
          }

          state.points[uid] = p
          paths_uid[point.path].nodes.push(p)
        }

        const r_done = {}
        for(let i=0; i < datas.relations.length; i ++){
          const r = datas.relations[i]
          const a = state.points[r["a"]]
          const b = state.points[r["b"]]

         /*let t= r["b"] + r["a"]
          if(r_done[t]) continue

          
          
          if(r.type === "normal" && a.next != null)  continue
          
          t = r["a"] + r["b"]
          r_done[t] = true*/
          

          
          if(r.type === "normal"){ 
            a.next = b
            b.pred = a

            

          } else if(r.type === "child"){ 
            a.children.push(b)
          }
        }

        return state

    } else {
      return
    }

}

  save() {
    let state = this.makeStateCopy()
    state.loading = true
    this.setState(state)
    const datas = this.getSaveMap(state)
    const uri = "/put/roads"
    fetch(uri, {
      method: "PUT",
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          roads: datas
      })
    }).then(async (response) => { 
      if(response.status === 200) { 
        state.loading = false
        this.clearSave(state)
        this.setState(state)
        
      }
    })
    
  }
  
  toggleAddMode(){
    let state = this.makeStateCopy()
    if(state.addMode){
      state.addMode = false
      state.floating_point = null
      if(state.select_path){
        state.select_path.node.point.select = false
      }
      state.select_path = null
    }
    else state.addMode = true
    this.setState(state)
  }

  getClosePoint (lngLat){
    if(!this.state.scene3D || !this.state.scene3D.map) return
    const pts = []
    const {x: x1, y:y1, z:z1} = this.state.scene3D.map.getPosition3D(lngLat)
    for(let l in this.state.points){
      const p = this.state.points[l]

      if(p.point.select) continue
      const {x: x2, y:y2, z:z2} = this.state.scene3D.map.getPosition3D(p.point.lngLat)
      
      const p1 = new THREE.Vector3( x1, y1, z1)
      const p2 = new THREE.Vector3( x2, y2, z2)
      
      const d1 = p1.distanceTo(p2)

      if(d1 < PAS_FOR_ROAD/2){
        pts.push(p)
        p.point.animate = true
      }
      else {
        p.point.animate = false
      }
    }
    return pts
  }

  getPointsUIDString(list){
    let uids = ""
    if(!list) return ""
    for(let i=0; i < list.length; i++){
      uids += list[i].point.uid
    }
    return uids
  }

  clearSelection(state){
    for(let l in state.points){
      const p = state.points[l]
      p.point.select = false
    }
  }
  removePath(path){
    let state = this.makeStateCopy()
    state.loading=true
    this.setState(state)
    let tmp = {}
    for(let uid  in state.points){
      const node = state.points[uid]
      if(node.path.uid !== path.uid){
        tmp[uid] = node
      }
      else { 
        if(node.point.sphere){
          state.scene3D.scene.remove(node.point.sphere);
        }
      }

    }
    state.points = tmp
    tmp = []
    for(let i=0; i < state.paths.length; i ++){
      const p = state.paths[i]
      if(p.uid != path.uid){
        tmp.push(p)
      }

    }
    state.paths = tmp
        const uri = `/post/remove/path/${path.uid}`
    fetch(uri, {
      method: "POST",
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
      }
    }).then(async (response) => { 
      if(response.status === 200) { 
        let state = this.makeStateCopy()
        state.loading = false
        this.setState(state)
        
      }
    })

  }

  removeNode(node){
    let state = this.makeStateCopy()
    if(node.point.sphere){
      state.scene3D.scene.remove(node.point.sphere);
    }
    if(node.next){
      node.next.pred = node.pred
    }
    if(node.pred){
      node.pred.next = node.next
    }

    if(node.children.length >= 0){
      node.children = []
    }

    let tmp = {}
    for(let uid in state.points){
      const n = state.points[uid]
      if(uid !== node.point.uid){
        tmp[uid] = n
      }
    }
    state.points = tmp
    tmp = []
    for(let i=0; i < node.path.nodes.length; i ++){
      const n = node.path.nodes[i]
      if(n.point.uid !== node.point.uid){
        tmp.push(n)
      }
    }
    node.path.nodes = tmp
    state.loading = true
    this.setState(state)    

    const uri = `/post/remove/node/${node.point.uid}`
    fetch(uri, {
      method: "POST",
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
      }
    }).then(async (response) => { 
      if(response.status === 200) { 
        let state = this.makeStateCopy()
        state.loading = false
        this.setState(state)
        
      }
    })

  }

  isPointbetweenTwoOthers (a, b, c) {
        
    if(Math.abs(a.x - b.x) > Math.abs(a.z - b.z)){
        if(a.x > b.x){
            const d = a
            a = b
            b = d
        }
        return c.x > a.x && c.x < b.x
    }
    else{
        if(a.z > b.z){
            const d = a
            a = b
            b = d
        }
        return c.z > a.z && c.z < b.z
    }
  }
  

  isBetweenPoint(lnglat, lnglat1, lnglat2){
    const {x: x, y:y, z:z} = this.state.scene3D.map.getPosition3D(lnglat)
    const {x: x1, y:y1, z:z1} = this.state.scene3D.map.getPosition3D(lnglat1)
    const {x: x2, y:y2, z:z2} = this.state.scene3D.map.getPosition3D(lnglat2)

    const a = new THREE.Vector3( x, y, z)
    const p1 = new THREE.Vector3( x1, y1, z1)
    const p2 = new THREE.Vector3( x2, y2, z2)
    const l = new THREE.Line3(p1, p2)
    const target = new THREE.Vector3();
    const d = l.closestPointToPoint(a, false, target).distanceTo(a);

    if(d < (PAS_FOR_ROAD/2) ){ 
      const d1 = p1.distanceTo(a)
      const d2 = p2.distanceTo(a)
      const t = this.isPointbetweenTwoOthers(p1, p2, a)
      if(t || d2 < (PAS_FOR_ROAD/4) || d1 < (PAS_FOR_ROAD/4)){ 
        return true
      }
    }
  }

  getNodeBetween (lngLat){
    if(!this.state.scene3D || !this.state.scene3D.map) return
    for(let l in this.state.points){
      const p = this.state.points[l]
      if(!p.next) continue
      if(p.path.uid ===  p.next.path.uid){ 
        if(this.isBetweenPoint(lngLat, p.point.lngLat, p.next.point.lngLat)){
          return [p, p.next, lngLat]
        }
      }
    }
    return []
  }

  onMouseMove(msg){
    let state = this.makeStateCopy()
    let change_state = true

    state.last_mouse_mv = msg.lngLat


    
    
    const points = this.getClosePoint(msg.lngLat)

    const l1 = this.getPointsUIDString(points)
    const l2 = this.getPointsUIDString(state.close_points)

    //console.log("onMouseMove")
    
   
    if(l1 !== l2){
      change_state = true
      state.close_points = points
    }

    if(this.state.addMode){
      if(state.select_path){
        
        state.floating_point = {
          "lngLat": msg.lngLat,
          "uid": "fak-" + uuidv4(),
          "select": false,
          "focused": false,
          trash: []
        }
        change_state = true
      }
    } else {
      if(mode_between_timer){
        clearInterval(mode_between_timer)
        mode_between_timer = null
        state.mode_between = false
        if(state.floatingBetween && state.floating_point.sphere){
          state.scene3D.scene.remove(state.floating_point.sphere);
        }
        state.floating_point = null
      }

      if(!state.mode_between && this.props.editMode === "paths"){
        const pointBetween = state.close_points && state.close_points.length > 0 ? null: this.getNodeBetween(msg.lngLat)
        if(pointBetween && pointBetween.length > 0){

          if(!mode_between_timer){
            mode_between_timer = setInterval(()=>{
              clearInterval(mode_between_timer)
               
              if(state.floating_between && state.floating_between.sphere){
                state.scene3D.scene.remove(state.floating_between.sphere);
              }
              state.floating_between = {
                "lngLat": state.last_mouse_mv,
                "uid": "fak-" + uuidv4(),
                "select": false,
                "animate": true,
                trash: []
              }
              state.pointBetween = pointBetween
              state.mode_between = true
              this.setState(state)
            }, 2000)
          }

          
          
        }else {
          if(state.floating_between && state.floating_between.sphere){
            state.scene3D.scene.remove(state.floating_between.sphere);
          }
          state.floating_between = null
          if(mode_between_timer){
            clearInterval(mode_between_timer)
            mode_between_timer = null
            state.mode_between = false
          }
        }
      }

      if(state.select_path && state.select_path.node.point.up === true  && this.props.editMode === "paths"){
        state.select_path.node.point.lngLat = msg.lngLat
        state.select_path.node.toSave = true
        state.select_path.node.path.toSave = true
        state.toSave = true
        change_state = true
      }
    }
    if(change_state) this.setState(state)
  }
  
  onMouseDwon(msg){
    let state = this.makeStateCopy()
    if(!this.state.addMode){
      if(state.close_points.length > 0){
        if(state.select_path){
          state.select_path.node.point.select = false
        }
        state.select_path = {
          node: state.close_points[0],
          path: state.close_points[0].path
        }
        state.accordion.path = state.close_points[0].path.uid
        state.accordion.point = state.close_points[0].point.uid
        this.clearSelection(state)
        state.select_path.node.point.select = true
        state.select_path.node.point.up = true
        this.props.notification.onNotification("MapDragPan", {enable: false}, {})
      } else if ( state.select_path && state.select_path.node.point.select === true && state.select_path.node.point.select_from === "accordion"){
        state.select_path.node.point.up = true
        state.select_path.node.point.select_from = ""
        this.props.notification.onNotification("MapDragPan", {enable: false}, {})
      } else if(state.select_path){
        state.select_path.node.point.select = false
        state.select_path.node.point.up = false
        this.props.notification.onNotification("MapDragPan", {enable: true}, {})
      }
    }
    this.setState(state)
    
  }
  onMouseUp(msg){
    let state = this.makeStateCopy()
    this.props.notification.onNotification("MapDragPan", {enable: true}, {})
    if(this.state.addMode){
      const point_gps = {
        "lngLat": msg.lngLat,
        "uid": "fak-" + uuidv4(),
        "select": true,
        "focused": false
      }
      const node = {
        point: point_gps,
        children: [],
        toSave: true,
        path: "",
        next: null,
        pred: null
      }
      state.points[point_gps.uid] = node

      if(!state.select_path){

          state.select_path = {}
          state.select_path.node = node
          const path = {
            nom: defaultLabel,
            "uid": "fak-" + uuidv4(),
            nodes:[node],
            toSave: true,
          }
          node.path = path
          state.paths.push(path)
          state.select_path.path = path
          state.toSave = true
        
      } else {
        state.points[point_gps.uid] = node
        state.select_path.node.point.select = false
        state.select_path.node.toSave = true
        if(state.select_path.node.pred !== null){
          state.select_path.node.pred.toSave = true
        }
        if(state.select_path.node.next !== null){
          state.select_path.node.next.toSave = true
        }
       
        if(state.select_path.node.pred === null && state.select_path.node.next !== null){
          state.select_path.node.pred = node
          node.next = state.select_path.node
        }
        else{
          if(state.select_path.node.pred !== null && state.select_path.node.next !== null){
            //state.select_path.node.children[node.point.uid] = node
            node.next = state.select_path.node
          }
          else{
            state.select_path.node.next = node
            node.pred = state.select_path.node
          }
        } 
        state.select_path.node = node
        state.select_path.path.toSave = true
        //state.select_path.path.renew = true
        state.select_path.path.nodes.push(node)
        node.path = state.select_path.path
        state.toSave = true
      }
    }
    else{
      if(state.select_path){
        state.select_path.node.point.up = false
        if(state.close_points.length > 0){
          const node = state.close_points[0]
          this.props.onAdminActionCaravanserailStreetLinking(state.select_path)
          if(node.point.uid !== state.select_path.node.point.uid ){ 
            console.log("Join", node.point.uid, state.select_path.node.point.uid)
            if(state.select_path.node.pred === null && state.select_path.node.next !== null){
              if(state.select_path.node.path.uid !== node.path.uid ){
                node.children[state.select_path.node.point.uid] = state.select_path.node
                node.toSave = true
                state.select_path.node.toSave = true
                state.toSave = true
              }
              else{
                state.select_path.node.pred = node
                state.toSave = true
                if(node.next === null){ 
                  node.next = state.select_path.node
                }  if(node.pred === null){ 
                    node.pred = state.select_path.node
                    node.children[state.select_path.node.point.uid] = state.select_path.node
                    node.toSave = true
                    state.select_path.node.toSave = true
                } else {
                  //node.children[state.select_path.node.point.uid] = state.select_path.node
                }
              }
                
            }
            else{
              if(state.select_path.node.pred !== null && state.select_path.node.next !== null){
                state.select_path.node.children[node.point.uid] = node
                node.toSave = true
                state.select_path.node.toSave = true
                state.toSave = true
                //node.next = state.select_path.node
              }
              else{
                if(state.select_path.node.path.uid !== node.path.uid ){
                  node.children[state.select_path.node.point.uid] = state.select_path.node
                  node.toSave = true
                  state.select_path.node.toSave = true
                  state.toSave = true
                }
                else{
                  state.select_path.node.next = node
                  state.select_path.node.next.toSave = true
                  state.toSave = true
                  node.toSave = true
                  if(node.pred === null){ 
                    node.pred = state.select_path.node
                    node.pred.toSave = true
                    
                  } else if(node.next === null){ 
                    node.next = state.select_path.node
                    node.next.toSave = true
                  } else {
                    //node.children[state.select_path.node.point.uid] = node
                  }
                }
              }
            } 
          }
        }
        //state.close_points = null
        //state.select_path.node.point.select = false
        //state.select_path = false
      }

      if(state.mode_between && state.pointBetween && state.pointBetween.length > 0){

        const p1 = state.pointBetween [0]
        const p2 = state.pointBetween [1]
        const lngLat = state.pointBetween [2]
        const node = {
          point: {
            "lngLat": lngLat,
            "uid": "fak-" + uuidv4(),
            "select": true,
            select_from: "accordion",
            "focused": false
          },
          children: [],
          toSave: true,
          path: p1.path,
          next: p2,
          pred: p1
        }

        p1.toSave = true
        p2.toSave = true
        p1.next = node
        p2.pred = node
        node.path.nodes.push(node)
        node.path.toSave = true
        node.path.renew = true
        state.points[node.point.uid] = node
        state.toSave = true
        if(state.floating_between && state.floating_between.sphere){
          state.scene3D.scene.remove(state.floating_between.sphere);
        }
        state.pointBetween = []
        state.mode_between = false
        state.select_path= {
          node: node,
          path: node.path
        }

        
        state.floating_between = null
      }
    }
    this.setState(state)
  }

  onChangeNom (index, nom){
    const state =this.makeStateCopy(true)
    if(!state.paths) return
    state.paths[index].nom = nom
    state.paths[index].toSave = true
    state.toSave = true
    const self = this
    setTimeout(()=>{
      self.setState(state)
    }, 10)
    
    
  }

  getDistanceBetweenTwoPoints(cord1, cord2) {
    if (cord1.lat == cord2.lat && cord1.lng == cord2.lng) {
      return 0;
    }
  
    const radlat1 = (Math.PI * cord1.lat) / 180;
    const radlat2 = (Math.PI * cord2.lat) / 180;
  
    const theta = cord1.lng - cord2.lng;
    const radtheta = (Math.PI * theta) / 180;
  
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  
    if (dist > 1) {
      dist = 1;
    }
  
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344; //convert miles to km
    
    return dist;
  }
  getSortedPoints(path) {
    if(!path.nodes) return []
    const t =  path.nodes.sort((a, b)=>{
      const d1 = this.getDistanceBetweenTwoPoints(a.point.lngLat, PointPoisition0)
      const d2 = this.getDistanceBetweenTwoPoints(b.point.lngLat, PointPoisition0)
      a.point.distance = d1
      b.point.distance = d2
      return d1 - d2
    })
    return t
  }
  render3D() {
    //console.log("render3D", this.props)
    if(this.state.version !== this.state.last_version && this.state.scene3D /*&& this.props.editMode === "paths"*/){ 
      const state = this.state
      for(var i=0;i< trash_path.length; i++){
        state.scene3D.scene.remove(trash_path[i]);
      }
      trash_path = []


      for(let uid in this.state.points){
        const node = this.state.points[uid]
        if(node.next){
          drawRoadFromTo(state.scene3D, node.point, node.next.point, trash_path)
        }
        for(let c in node.children){
          drawRoadFromTo(state.scene3D, node.point, node.children[c].point, trash_path)
        }
        manageSelection(state.scene3D, node.point)
      }

      if(trash_floating.length > 0){
        for(var i=0;i< trash_floating.length; i++){
          state.scene3D.scene.remove(trash_floating[i]);
        }
        trash_floating = []
      }

      if(state.select_path && state.floating_point ){ 
        
        drawRoadFromTo(state.scene3D, state.select_path.node.point, state.floating_point, trash_floating)
      }
      else if(state.floating_between){
        if(state.floating_between.sphere) state.scene3D.scene.remove(state.floating_between.sphere);
        state.floating_between.sphere = undefined
        manageSelection(state.scene3D, state.floating_between)
      }
      state.last_version = state.version 
      this.setState(state)
    }
  }

  render() {
    
    return (
        <>
          <LoadingOverlay visible={this.state.loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
          <Drawer  className={"drawer-chemin"} opened={this.props.editMode === "paths"} size={isMobile?"xs":"sm"}
          overlayProps={{ backgroundOpacity: 0, display:"none" }} withCloseButton={false} style={{"margin": "auto"}}>
            <CloseButton style={{"top": "0rem", "right": "0rem", position: "absolute"}} icon={<IconXboxX size={18} stroke={1.5} />} onClick={()=>this.props.onEditMode("")} />
            <Paper style={{"paddingTop": "2rem"}} className='ui-element'>
              <Button style={{"top": "1rem", "right": "1.5rem", position: "absolute"}} className={this.state.addMode ? "filled" : "default"} variant={this.state.addMode ? "" : "default"} leftSection={<IconRouteSquare size={14} />} onClick={()=>{this.toggleAddMode()}}>Ajout</Button>
              <Divider my="md" />
            </Paper>
              <ScrollArea h={`${this.state.toSave?"calc(100% - 6rem)":"100%"}`}>
                  <Accordion className='accordion' value={this.state.accordion.path} onChange={(value)=>{
                                        const state = this.makeStateCopy()
                                        state.accordion.path = value
                                        this.setState(state)
                                    }}>
                    {
                      this.state.paths.map((path, index) => (
                        <Accordion.Item key={index} value={`${path.uid}`}>
                          <Accordion.Control>
                              <h2>{
                                path.nom ? (<><span>{path.nom} </span><CopyUidLink uid={path.uid} /></>):(defaultLabel)
                              }</h2>
                          </Accordion.Control>
                          <Accordion.Panel>
                            <div className="flex-center">
                              <ActionIcon variant="filled" aria-label="Settings" onClick={()=>{
                                  this.props.notification.onNotification("NavigateLngLat", path.nodes[0].point.lngLat)
                              }}><IconEye size={14}/></ActionIcon>
                              <TextInput placeholder={defaultLabel} value={path.nom?path.nom:""} onChange={(e)=>{this.onChangeNom(index, e.target.value);}}/>

                              <Popover opened={path.must_delete===true}>
                                <Popover.Target>
                                    <ActionIcon variant="filled" color="red" aria-label="Settings" onClick={()=>{
                                      this.props.notification.onNotification("NavigateLngLat", path.nodes[0].point.lngLat)
                                      const state = this.makeStateCopy()
                                      
                                      path.must_delete = true
                                      this.setState(state)

                                      setTimeout(()=>{
                                        path.must_delete = false
                                        this.setState(state)
                                      }, 5000)
                                      
                                  }}><IconSquareRoundedXFilled size={14}/></ActionIcon>
                                </Popover.Target>
                                <Popover.Dropdown>
                                  
                                  <Button color="red" leftSection={<IconSquareRoundedXFilled size={14} />} onClick={()=>{
                                      this.removePath(path)
                                      
                                  }}>Réellement supprimer ce chemin?</Button>
                                  <CloseButton  onClick={()=>{
                                      const state = this.makeStateCopy()
                                      path.must_delete = false
                                      this.setState(state)
                                  }} />
                                </Popover.Dropdown>
                              </Popover>
                            </div>
                            <ScrollArea h={300}>
                              <Accordion value={this.state.accordion.point} onChange={(value)=>{
                                                                      const state = this.makeStateCopy()
                                                                      state.accordion.point = value
                                                                      this.setState(state)}}>
                                {
                                  this.getSortedPoints(path).map((node, pindex) => (
                                    <Accordion.Item key={pindex} value={`${node.point.uid}`}>
                                        <Accordion.Control>Segment: {pindex + 1}  <CopyUidLink uid={node.point.uid}/></Accordion.Control>
                                        <Accordion.Panel style={{display: "flex"}}>
                                          <p style={{marginLeft: "1rem", marginRight: "1rem", cursor:"pointer", margin:"auto", "textAlign": "left", display:"flex"}} onClick={()=>{
                                              this.props.notification.onNotification("NavigateLngLat", node.point.lngLat)}}>
                                              <span style={{"marginRight" : "1rem"}}>@{node.point.lngLat.lat.toFixed(2)},{node.point.lngLat.lng.toFixed(2)}</span>
                                              

                                              <ActionIcon style={{"marginRight" : "0.5rem"}} variant="filled" aria-label="Settings" onClick={()=>{
                                                    this.props.notification.onNotification("NavigateLngLat", node.point.lngLat )
                                                    const state = this.makeStateCopy()
                                                    state.select_path = {
                                                              node: node,
                                                              path: node.path
                                                            }

                                                    this.clearSelection(state)
                                                    state.select_path.node.point.select = true
                                                    state.select_path.node.point.select_from = "accordion"
                                                    this.setState(state)
                                              }}>
                                                  <IconEye size={14}/>
                                              </ActionIcon>
                                              <Popover opened={node.must_delete===true}>
                                                <Popover.Target>
                                                    <ActionIcon variant="filled" color="red" aria-label="Settings" onClick={()=>{
                                                      this.props.notification.onNotification("NavigateLngLat", node.point.lngLat )
                                                      const state = this.makeStateCopy()
                                                      
                                                      node.must_delete = true
                                                      state.select_path = {
                                                              node: node,
                                                              path: node.path
                                                            }

                                                      this.clearSelection(state)
                                                      state.select_path.node.point.select = true
                                                      state.select_path.node.point.select_from = "accordion"
                                                      this.setState(state)

                                                      setTimeout(()=>{
                                                        node.must_delete = false
                                                        this.setState(state)
                                                      }, 5000)
                                                      
                                                  }}><IconSquareRoundedXFilled size={14}/></ActionIcon>
                                                </Popover.Target>
                                                <Popover.Dropdown>
                                                  <Button color="red" leftSection={<IconSquareRoundedXFilled size={14} />} onClick={()=>{
                                                  
                                                      this.removeNode(node)
                                                  }}>Réellement supprimer ?</Button>
                                                  <CloseButton  onClick={()=>{
                                                      const state = this.makeStateCopy()
                                                      node.must_delete = false
                                                      this.setState(state)
                                                  }} />
                                                </Popover.Dropdown>
                                              </Popover>
                                          </p>
                                        </Accordion.Panel>
                                    </Accordion.Item>
                                  ))
                                }
                              </Accordion>
                            </ScrollArea>
                          </Accordion.Panel>
                        </Accordion.Item>
                      )
                    )}
                  </Accordion>
                  {
                      this.state.toSave === true?(<Button style={{ "width": "60%", "marginTop": "1rem"}} rightSection={<IconDeviceFloppy size={14} />} onClick={()=>{this.save()}}>Sauvegarde</Button>):""
                  }

              </ScrollArea>
            
          </Drawer>
        </>
    )
  }

}


const mapDispatchToProps = {
  onEditMode: onEditMode,
  onAdminActionCaravanserailStreetLinking: onAdminActionCaravanserailStreetLinking
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification
    }
}


PathEditor = connect(mapStateToProps, mapDispatchToProps)(PathEditor);

export default PathEditor;